module.exports = __webpack_public_path__ + "static/media/whatsapp-min.53f79a96.png";